// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_32bbee5fda--wrapper--f7HL_"};